import { DividaResource } from '@/models/resources';
import { IOrdemSalvaOrderingService } from '../interfaces/IOrdemSalvaOrderingService';
import { DividasOrderingService } from '../../DividasOrderingService';
import { IOrdenacaoStrategy } from '../interfaces/IOrdenacaoStrategy';
import { TipoOrdenacao } from '../types/TipoOrdenacao';

/**
 * Estratégia de ordenação por ordem salva na sessionStorage
 */
export class OrdenacaoPorOrdemSalvaStrategy implements IOrdenacaoStrategy {
  private readonly service: IOrdemSalvaOrderingService;

  constructor(orderingService: IOrdemSalvaOrderingService) {
    this.service = orderingService;
  }

  ordenar(lote: DividaResource[], tipoOrdenacao: TipoOrdenacao): DividaResource[] {
    if (tipoOrdenacao !== TipoOrdenacao.ORDEM_SALVA) {
      throw new Error(
        `Tipo de ordenação ${tipoOrdenacao} não suportado por esta estratégia`,
      );
    }

    // Quando o lote já vem ordenado (ex: do cache de lotes), apenas retorna como está
    // A ordem já está preservada nas chaves do cache de lotes
    // Só reordena usando dividasOrder se estiver disponível e não vazio
    const dividasOrder = this.service.getDividasOrder();
    if (
      !dividasOrder
      || !Array.isArray(dividasOrder)
      || dividasOrder.length === 0
    ) {
      return lote;
    }

    // Reordena usando dividasOrder
    this.service.resetIfExpired();

    const dividasOrdenadas: DividaResource[] = [];
    const dividasNaoOrdenadas = [...lote];

    dividasOrder.forEach((key: string) => {
      const index = dividasNaoOrdenadas.findIndex(
        (d) => DividasOrderingService.calcularKey(d.api, d.id) === key,
      );
      if (index !== -1) {
        dividasOrdenadas.push(dividasNaoOrdenadas[index]);
        dividasNaoOrdenadas.splice(index, 1);
      }
    });

    dividasOrdenadas.push(...dividasNaoOrdenadas);

    return dividasOrdenadas;
  }
}
